<template>
    <div class="row">
      <div class="col-sm-12">
        <table ref="table" class="display table table-bordered table-hover table-responsive" cellspacing="0"
               width="100%">
          <thead>
            <tr>
              <th class="align-center">Id</th>
              <th class="align-center">Code</th>
              <th class="align-center">Discount percent</th>
              <th class="align-center">Status</th>
              <th class="align-center">Multiple?</th>
              <th class="align-center">Created at</th>
              <th class="align-center">Actions</th>
            </tr>
          </thead>
          <tfoot>
            <tr>
              <th class="align-center">Id</th>
              <th class="align-center">Code</th>
              <th class="align-center">Discount percent</th>
              <th class="align-center">Status</th>
              <th class="align-center">Multiple?</th>
              <th class="align-center">Created at</th>
              <th class="align-center">Actions</th>
            </tr>
          </tfoot>
          <tbody>
            <tr v-for="code in codes">
              <td>{{code.id}}</td>
              <td>{{code.code}}</td>
              <td>{{code.percent}}</td>
              <td v-html="formatStatus(code.status, code.user)"></td>
              <td>{{code.is_permanent ? 'Yes' : 'No'}}</td>
              <td>{{code.created_at}}</td>
              <td class="align-center">
                <template v-if="code.active && !code.user_id">
                  <a :href="listLink + '/' +  code.id + '/edit'">Edit</a>
                  <br>
                  <a @click="copyRegisterLink(code)" href="#">Copy link</a>
                </template>
              </td>
            </tr>
          </tbody>
        </table>
      </div>
    </div>
</template>

<script>
export default {
  props: {
    codes: {
      required: true,
      type: Array,
    },
    listLink: {
      required: true,
      type: String,
    },
    signUpLink: {
      required: false,
      type: [String, null],
    },
    illustratorsIndexLink: {
      required: true,
      type: String,
    },
  },
  mounted() {
    this.initDatatable();
  },
  methods: {
    initDatatable() {
      $(this.$refs.table).DataTable({
        responsive: true,
        ordering: false,
        searching: false,
      });
    },
    copyRegisterLink(code) {
      const el = document.createElement('textarea');

      el.value = `${this.signUpLink}?discount_code=${code.code}`;
      el.setAttribute('readonly', '');
      el.style.position = 'absolute';
      el.style.left = '-9999px';
      document.body.appendChild(el);
      el.select();
      document.execCommand('copy');
      document.body.removeChild(el);

      toastr.success('Sign up link with discount code was copied into clipboard successfully');
    },
    formatStatus(status, user) {
      if ((status.indexOf('Applied') === -1) && (status.indexOf('Registered') === -1)) return status;

      if (!user || !user.illustrator) return status;


      let replaceLink = `<a target="_blank" href="${this.illustratorsIndexLink}/${user.illustrator.id}/edit">${user.name}</a>`;

      return status.replace(user.name, replaceLink);
    },
  }
};
</script>